<template>
  <div class="card" style="max-width:300px;">
    <div class="card-header">{{ title }}</div>
    <div class="card-body">
      <h6>{{ address.name1 || address.title }}</h6>
      <p>{{ address.name2 || address.subtitle }}</p>
      <p>{{ address.street }}</p>
      <p>{{ address.pcode }}&nbsp;{{ address.city }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Address',
  props: ["address","title"]
}
</script>
